import React, { useState } from "react";
import { Box, Button, Flex, Heading, Spinner, Text } from "@chakra-ui/react";
import { useUser } from "../../../../hooks/V2/useUser";
import useSnackBar from "../../../common/V2/Snackbar";
import { signIn, updateUser, verifyPhoneSendOtp } from "../../../../apis/V2/auth";
import { phoneRegExp } from "./ProfileFieldCard";
import { useMutation } from "react-query";
import { axiosErrorHandler } from "../../../../apis/axios";
import InputCustom from "../../../common/InputCustom";

interface Props {
	updatedPhone: string;
	setUpdatedPhone: React.Dispatch<React.SetStateAction<string>>;
	showPhoneOtpModal: boolean;
	setShowPhoneOtpModal: React.Dispatch<React.SetStateAction<boolean>>;
    showUpdatePhoneModal: boolean;
	setShowUpdatePhoneModal:React.Dispatch<React.SetStateAction<boolean>>;
}

const UpdatePhoneModalContent = ({
  showPhoneOtpModal,
  setShowPhoneOtpModal,
  updatedPhone,
  setUpdatedPhone,
  showUpdatePhoneModal,
  setShowUpdatePhoneModal
}: Props) => {
  const { data: profile } = useUser();
  const snackbar = useSnackBar();

  const { mutate: updatePhoneMutate, isLoading: isUpdateEmailLoading } = useMutation(
	  updateUser,
	  {
	    onSuccess: (data) => {
        sendPhoneOtpMutate();
	      snackbar.success("Phone number updated successfully");
	    },
	    onError: (error) => {
	      const e = axiosErrorHandler(error);
	      if (typeof e === "object" && "message" in e) {
	        snackbar.error(e.message);
	      } else {
	        snackbar.error("Something went wrong");
	      }
	    },
	  }
	);

  const { mutate: sendPhoneOtpMutate, isLoading: sendPhoneOtpLoading } = useMutation(
    verifyPhoneSendOtp,
    {
      onSuccess: (data) => {
        snackbar.success("Otp sent on mobile!");
        if (!showPhoneOtpModal) {
          setShowUpdatePhoneModal(false);
          setShowPhoneOtpModal(true);
        }
      },
      onError: (error) => {
        const e = axiosErrorHandler(error);
        if (typeof e === "object" && "message" in e) {
          snackbar.error(e.message);
        } else {
          snackbar.error("Something went wrong");
        }
      },
    }
  );

  return (
    <Box>
      <Heading as="h4">
        {profile?.phoneNumber ? "Update your mobile number" : "Add your mobile number"}
      </Heading>
      {profile?.phoneNumber && (
        <>
          <Text mt={"ms-16"} textStyle="body2" color="ms-grey.700">
            Your current mobile number:
          </Text>
          <Text mb={"ms-8"} mt={"ms-4"} textStyle="body2-md" color="ms-grey.700">
            {profile?.phoneNumber}
          </Text>
        </>
      )}
      <Text mt={"ms-24"} mb={"ms-8"} textStyle="body2-md" color="ms-grey.800">
        {profile?.phoneNumber
          ? "Please enter your new mobile number"
          : "Please enter your mobile number"}
      </Text>
      <InputCustom
        required
        type="tel"
        isInvalid={updatedPhone !== "" && !phoneRegExp.test(updatedPhone)}
        getValueCallback={(value) => {
          setUpdatedPhone(value);
        }}
        errorMessage={"Please enter a valid 10 digit mobile number"}
        placeholder="Enter your new mobile number"
        onClick={() => {
          //
        }}
      />
      <Flex>
        <Button
          mt={updatedPhone !== "" && !phoneRegExp.test(updatedPhone) ? "14px" : "46px"}
          onClick={() => {
            updatePhoneMutate({phoneNumber:updatedPhone})
          }}
          size="md"
          variant="primary"
          ml={"auto"}
          disabled={!updatedPhone || sendPhoneOtpLoading || !phoneRegExp.test(updatedPhone)}
          position={sendPhoneOtpLoading ? "relative" : "static"}
        >
          update & verify
          {sendPhoneOtpLoading && (
            <Spinner
              speed={"0.5s"}
              thickness={"2px"}
              size={"md"}
              position={"absolute"}
              color={"ms-blue.500"}
            />
          )}
        </Button>
      </Flex>
    </Box>
  );
};

export default UpdatePhoneModalContent;
